import { useLocale } from "../i18n/useLocale.js";
import { buildPlanMetrics } from "./planMetrics";

export function PlanSummaryStrip({ layout, projects }) {
  const { display } = useLocale();
  const metrics = buildPlanMetrics(layout, projects);
  const statusMessage = metrics.statusKey
    ? display.t(metrics.statusKey, metrics.statusParams)
    : "";

  if (metrics.invalidCount === 0 || !statusMessage) return null;

  return (
    <div className="canvas-inline-alert" aria-live="polite" role="status">
      {statusMessage}
    </div>
  );
}
